import { $get } from 'dashboard-js/helpers'
import UserProvider from 'dashboard-js/providers/UserProvider'

export default class {
    static start() {
        setTimeout(() => this.refreshAccessTokens(), 5000)
    }

    static all() {
        return $get(UserProvider.authUser(), 'channels', [])
    }

    static refreshAccessTokens() {
        this.all()
            .filter(channel => $get(channel, 'token_refresh_is_due') === true)
            .forEach(channel => {
                axios.post(route('api.channel.refresh-token', channel.id)).then(response => {
                    fetch(
                        `https://graph.facebook.com/oauth/access_token?code=${
                            response.data.data.code
                        }&client_id=${Spark.facebook.app_id}&redirect_uri=${
                            Spark.facebook.redirect_uri
                        }`
                    )
                        .then(response => response.json())
                        .then(response => {
                            axios.put(route('api.channel.update', channel.id), {
                                resource_id: channel.resource_id,
                                token: response.access_token,
                                token_expires_at: moment().add(response.expires_in, 'seconds'),
                            })
                        })
                })
            })
    }
}
